export const REPORT_SECTIONS = [
  ['pages', 'Viewed pages and sections', 'requestPath'],
  ['sources', 'Traffic sources', 'referrerHostname'],
  ['countries', 'Approximate countries', 'country'],
  ['devices', 'Devices', 'deviceType'],
  ['browsers', 'Browsers', 'browserName'],
  ['operatingSystems', 'Operating systems', 'osName'],
  ['events', 'Interactions', 'eventName'],
  ['landings', 'Landing sections', 'eventData'],
];

function safeCell(value) {
  const text = String(value ?? '');
  const escaped = /^[\s]*[=+@-]/.test(text) || /^[\t\r\n]/.test(text) ? `'${text}` : text;
  return `"${escaped.replace(/"/g, '""')}"`;
}

export function reportCsv(report) {
  const rows = [['section', 'date_or_value', 'pageviews_or_events', 'visitors']];
  (report.daily || []).forEach((row) => rows.push(['Daily visit history', row.timestamp || '', row.pageviews || 0, row.visitors || 0]));
  REPORT_SECTIONS.forEach(([key, label, field]) => {
    (report[key] || []).forEach((row) => rows.push([label, row[field] || 'Direct / unknown', key === 'events' || key === 'landings' ? row.count || 0 : row.pageviews || 0, key === 'events' || key === 'landings' ? '' : row.visitors || 0]));
  });
  return `\uFEFF${rows.map((row) => row.map(safeCell).join(',')).join('\r\n')}\r\n`;
}
